import forge from "node-forge";
import { v4 } from "uuid";
import CryptoJS from "crypto-js";
let key = process.env.REACT_APP_ENCRYPTION_KEY;
const ENC_SECURE_KEY = process.env.REACT_APP_ENC_SECURE_KEY;

key = decodeURIComponent(key);

function generateUUID(length = 36) {
  const uuidV = v4().slice(0, length);
  return uuidV;
}
function encrypt(text) {
  let iv = generateUUID(16);
  let cipher = forge.cipher.createCipher("AES-CBC", key);
  cipher.start({ iv: iv });
  cipher.update(forge.util.createBuffer(text, "utf8"));
  cipher.finish();
  let encrypted = cipher.output;
  let d = forge.util.encode64(encrypted.data);
  return `${d}|${iv}`;
}
function decrypt(encryptedText) {
  const splittedText = encryptedText?.split("|");
  const [encData, iv] = [splittedText[0], splittedText[1]];
  let decipher = forge.cipher.createDecipher("AES-CBC", key);
  decipher.start({ iv: iv });
  decipher.update(forge.util.createBuffer(forge.util.decode64(encData)));
  let result = decipher.finish();
  if (result) {
    return decipher.output.data;
  } else {
    throw new Error("Could not decrypt");
  }
}

const stringEncryptData = (data) => {
  try {
    const ciphertext = CryptoJS.AES.encrypt(
      data.toString(),
      ENC_SECURE_KEY
    ).toString();
    return ciphertext;
  } catch (error) {
    throw error;
  }
};

const stringDecryptData = (data) => {
  try {
    const bytes = CryptoJS.AES.decrypt(data.toString(), ENC_SECURE_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData;
  } catch (error) {
    throw error;
  }
};

const jsonEncryptData = (data) => {
  try {
    const jsonStr = JSON.stringify(data);
    const ciphertext = CryptoJS.AES.encrypt(jsonStr, ENC_SECURE_KEY).toString();
    return ciphertext;
  } catch (error) {
    throw error;
  }
};

const jsonDecryptData = (data) => {
  try {
    const bytes = CryptoJS.AES.decrypt(data.toString(), ENC_SECURE_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    throw error;
  }
};

const secureData = (data, type) => {
  switch (type) {
    case "string_encrypt":
      return stringEncryptData(data);
    case "json_encrypt":
      return jsonEncryptData(data);
    case "string_decrypt":
      return stringDecryptData(data);
    case "json_decrypt":
      return jsonDecryptData(data);
    default:
      return "no expression";
  }
};

export { encrypt, decrypt, secureData };
